(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["unplastiq-benefits"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('unplastiq-benefits')) {
    customElements.define('unplastiq-benefits', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.setup());
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.io?.disconnect();
      }
      setup() {
        this.io?.disconnect();
        const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
        const designMode = window.Shopify && Shopify.designMode;
        if (!this.classList.contains('ib--animate') || reduce || designMode || !('IntersectionObserver' in window)) return;
        this.classList.add('is-armed');
        this.io = new IntersectionObserver(entries => {
          if (entries.some(e => e.isIntersecting)) {
            this.classList.add('is-visible');
            this.io.disconnect();
          }
        }, {threshold: 0.2});
        this.io.observe(this);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["unplastiq-instagram"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('unplastiq-instagram')) {
    customElements.define('unplastiq-instagram', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.setup());
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.events?.abort();
        this.observer?.disconnect();
      }
      setup() {
        this.events?.abort();
        this.observer?.disconnect();
        this.events = new AbortController();
        const options = {signal:this.events.signal};
        this.track = this.querySelector('.ig__track');
        this.slides = [...this.querySelectorAll('[data-ig-slide]')];
        this.prev = this.querySelector('[data-ig-prev]');
        this.next = this.querySelector('[data-ig-next]');
        this.arrows = this.querySelector('.ig__arrows');
        if (!this.track) return;
        this.prev?.addEventListener('click', () => this.page(-1), options);
        this.next?.addEventListener('click', () => this.page(1), options);
        this.track.addEventListener('scroll', () => this.update(), {...options,passive:true});
        this.addEventListener('shopify:block:select', e => {
          const slide = e.target.closest('[data-ig-slide]');
          if (slide) this.track.scrollTo({left:slide.offsetLeft - parseFloat(getComputedStyle(this.track).paddingLeft),behavior:'instant'});
        }, options);
        this.observer = new ResizeObserver(() => this.measure());
        this.observer.observe(this.track);
        this.measure();
        this.loadFeed();
      }
      notice(message) {
        console.warn('[Unplastiq Instagram] ' + message);
        const el = this.querySelector('[data-ig-notice]');
        if (el && window.Shopify && Shopify.designMode) {
          el.textContent = message;
          el.hidden = false;
        }
      }
      async loadFeed() {
        const token = (this.dataset.token || '').trim();
        if (!token) return;
        const count = Math.min(24, Math.max(1, parseInt(this.dataset.count, 10) || 10));
        const signal = this.events.signal;
        const key = 'unplastiq-ig-' + token.slice(-10) + '-' + count;
        let feed = null;
        try {
          const cached = JSON.parse(sessionStorage.getItem(key) || 'null');
          if (cached && Date.now() - cached.time < 30 * 60 * 1000) feed = cached;
        } catch (e) {}
        if (!feed) {
          try {
            const fields = 'id,media_type,media_url,thumbnail_url,permalink,caption';
            const enc = encodeURIComponent(token);
            const [mediaRes, meRes] = await Promise.all([
              fetch('https://graph.instagram.com/me/media?fields=' + fields + '&limit=' + count + '&access_token=' + enc, {signal}),
              fetch('https://graph.instagram.com/me?fields=username&access_token=' + enc, {signal})
            ]);
            if (!mediaRes.ok) throw new Error('Instagram returned status ' + mediaRes.status + '. The access token may have expired.');
            const media = await mediaRes.json();
            const me = meRes.ok ? await meRes.json() : {};
            const items = (media.data || [])
              .map(post => ({
                image: post.media_type === 'VIDEO' ? post.thumbnail_url : post.media_url,
                link: post.permalink,
                alt: (post.caption || '').split('\n')[0].slice(0, 120)
              }))
              .filter(post => post.image && /^https:\/\/(www\.)?instagram\.com\//.test(post.link || ''))
              .slice(0, count);
            feed = {time: Date.now(), username: me.username || '', items};
            try { sessionStorage.setItem(key, JSON.stringify(feed)); } catch (e) {}
          } catch (error) {
            if (error.name === 'AbortError') return;
            this.notice('Instagram feed could not load, so the hand-picked posts are shown. ' + error.message);
            return;
          }
        }
        if (!feed.items.length) {
          this.notice('No posts found on this Instagram account, so the hand-picked posts are shown.');
          return;
        }
        this.render(feed);
      }
      render(feed) {
        const fragment = document.createDocumentFragment();
        feed.items.forEach(item => {
          const li = document.createElement('li');
          li.className = 'ig__slide';
          li.setAttribute('data-ig-slide', '');
          const a = document.createElement('a');
          a.className = 'ig__tile';
          a.href = item.link;
          a.target = '_blank';
          a.rel = 'noopener';
          a.setAttribute('aria-label', (item.alt || 'View this post on Instagram') + ' (opens in a new tab)');
          const img = document.createElement('img');
          img.src = item.image;
          img.alt = item.alt;
          img.loading = 'lazy';
          img.decoding = 'async';
          a.append(img);
          li.append(a);
          fragment.append(li);
        });
        this.track.replaceChildren(fragment);
        this.slides = [...this.querySelectorAll('[data-ig-slide]')];
        this.track.scrollLeft = 0;
        const follow = this.querySelector('[data-ig-follow]');
        if (follow && follow.hasAttribute('hidden') && feed.username) {
          follow.href = 'https://www.instagram.com/' + encodeURIComponent(feed.username) + '/';
          follow.hidden = false;
        }
        this.measure();
      }
      measure() {
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        if (this.arrows) this.arrows.hidden = max < 3;
        this.update();
      }
      update() {
        if (!this.prev || !this.next) return;
        const x = this.track.scrollLeft;
        this.prev.disabled = x <= 2;
        this.next.disabled = x >= this.track.scrollWidth - this.track.clientWidth - 2;
      }
      page(direction) {
        const first = this.slides[0];
        if (!first) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = first.getBoundingClientRect().width + gap;
        const usable = this.track.clientWidth - parseFloat(getComputedStyle(this.track).paddingLeft);
        const visible = Math.max(1, Math.floor((usable + gap) / step + 0.05));
        this.track.scrollBy({
          left: direction * step * visible,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["unplastiq-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('unplastiq-reviews')) {
    customElements.define('unplastiq-reviews', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.setup());
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        clearTimeout(this.timer);
        this.events?.abort();
        this.observer?.disconnect();
        this.inView?.disconnect();
      }
      setup() {
        this.events?.abort();
        this.observer?.disconnect();
        this.inView?.disconnect();
        clearTimeout(this.timer);
        this.events = new AbortController();
        const options = {signal:this.events.signal};
        this.track = this.querySelector('.ur__track');
        this.cards = [...this.querySelectorAll('[data-ur-card]')];
        this.prev = this.querySelector('[data-ur-prev]');
        this.next = this.querySelector('[data-ur-next]');
        this.toggle = this.querySelector('[data-ur-toggle]');
        this.dots = this.querySelector('.ur__dots');
        this.arrows = this.querySelector('.ur__arrows');
        if (!this.track) return;

        /* Auto slide state */
        const reduce = matchMedia('(prefers-reduced-motion: reduce)');
        this.interval = Math.max(2000, parseInt(this.dataset.interval, 10) || 5000);
        this.pauseOnHover = this.dataset.pauseHover !== 'false';
        this.autoEnabled = this.dataset.autoplay === 'true' && !reduce.matches && !(window.Shopify && Shopify.designMode);
        this.userPaused = false;
        this.hovering = false;
        this.focusing = false;
        this.touching = false;
        this.visible = true;
        this.pageVisible = !document.hidden;

        this.prev.addEventListener('click', () => { this.go(this.index - 1); this.schedule(); }, options);
        this.next.addEventListener('click', () => { this.go(this.index + 1); this.schedule(); }, options);
        this.track.addEventListener('scroll', () => this.update(), {...options,passive:true});
        this.track.addEventListener('keydown', e => {
          if (e.target !== this.track) return;
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault();this.go(this.index + (e.key === 'ArrowRight' ? 1 : -1));this.schedule();
          }
        }, options);
        this.addEventListener('shopify:block:select', e => {
          const card = this.cards.find(c => c.dataset.blockId === e.detail.blockId);
          if (card) {
            const x = card.getBoundingClientRect().left - this.cards[0].getBoundingClientRect().left;
            this.track.scrollTo({left:x,behavior:'instant'});
          }
        }, options);

        if (this.toggle) {
          this.toggle.hidden = !this.autoEnabled;
          this.toggle.addEventListener('click', () => {
            this.userPaused = !this.userPaused;
            this.renderToggle();
            this.schedule();
          }, options);
        }

        if (this.autoEnabled) {
          if (this.pauseOnHover) {
            this.addEventListener('mouseenter', () => { this.hovering = true; this.schedule(); }, options);
            this.addEventListener('mouseleave', () => { this.hovering = false; this.schedule(); }, options);
          }
          /* Keyboard focus pauses; mouse clicks on the arrows do not */
          this.addEventListener('focusin', e => {
            if (e.target.matches(':focus-visible')) { this.focusing = true; this.schedule(); }
          }, options);
          this.addEventListener('focusout', () => { this.focusing = false; this.schedule(); }, options);
          /* Touch: pause while the finger is down and shortly after */
          this.track.addEventListener('touchstart', () => { this.touching = true; this.schedule(); }, {...options,passive:true});
          this.track.addEventListener('touchend', () => { this.touching = false; this.schedule(); }, {...options,passive:true});
          this.track.addEventListener('touchcancel', () => { this.touching = false; this.schedule(); }, {...options,passive:true});
          document.addEventListener('visibilitychange', () => { this.pageVisible = !document.hidden; this.schedule(); }, options);
          if ('IntersectionObserver' in window) {
            this.inView = new IntersectionObserver(entries => {
              this.visible = entries[entries.length-1].isIntersecting;
              this.schedule();
            }, {threshold:0.25});
            this.inView.observe(this);
          }
        }

        this.observer = new ResizeObserver(() => this.measure());
        this.observer.observe(this.track);
        this.measure();
      }
      renderToggle() {
        if (!this.toggle) return;
        const paused = this.userPaused;
        this.toggle.querySelector('[data-ur-icon-pause]').hidden = paused;
        this.toggle.querySelector('[data-ur-icon-play]').hidden = !paused;
        this.toggle.setAttribute('aria-label', paused ? 'Start automatic sliding' : 'Pause automatic sliding');
      }
      canRun() {
        return this.autoEnabled && this.positions && this.positions.length > 1 &&
          !this.userPaused && !this.hovering && !this.focusing && !this.touching &&
          this.visible && this.pageVisible;
      }
      schedule() {
        clearTimeout(this.timer);
        if (!this.canRun()) return;
        this.timer = setTimeout(() => {
          this.advance();
          this.schedule();
        }, this.interval);
      }
      advance() {
        const atEnd = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 2;
        this.go(atEnd ? 0 : this.index + 1);
      }
      measure() {
        const max = Math.max(0,this.track.scrollWidth-this.track.clientWidth);
        this.positions = [0];
        if (this.cards.length) {
          const first = this.cards[0].getBoundingClientRect().left;
          this.cards.forEach(card => {
            const x = Math.min(max,Math.max(0,card.getBoundingClientRect().left-first));
            if (x - this.positions[this.positions.length-1] > 2) this.positions.push(x);
          });
        }
        this.arrows.hidden = max < 3;
        this.dots.hidden = max < 3;
        this.dots.replaceChildren();
        this.positions.forEach((x,i) => {
          const b = document.createElement('button');
          b.type='button';b.className='ur__dot';
          b.setAttribute('aria-label',`Show review position ${i+1} of ${this.positions.length}`);
          b.setAttribute('aria-controls',this.track.id);
          b.addEventListener('click',()=>{this.go(i);this.schedule();},{signal:this.events.signal});
          this.dots.append(b);
        });
        this.update();
        this.renderToggle();
        this.schedule();
      }
      update() {
        if (!this.positions) return;
        const x = this.track.scrollLeft;
        this.index = this.positions.reduce((best,pos,i) => Math.abs(pos-x)<Math.abs(this.positions[best]-x)?i:best,0);
        this.prev.disabled = x <= 2;
        this.next.disabled = x >= this.track.scrollWidth-this.track.clientWidth-2;
        [...this.dots.children].forEach((b,i)=>b.setAttribute('aria-current',String(i===this.index)));
      }
      go(index) {
        const target = Math.max(0,Math.min(this.positions.length-1,index));
        this.track.scrollTo({left:this.positions[target],behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["unplastiq-shop-categories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('unplastiq-categories')) {
    customElements.define('unplastiq-categories', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.setup());
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.events?.abort();
        this.observer?.disconnect();
      }
      setup() {
        this.events?.abort();
        this.observer?.disconnect();
        this.events = new AbortController();
        const options = {signal:this.events.signal};
        this.carousel = this.querySelector('.uc__carousel');
        this.track = this.querySelector('.uc__track');
        this.slides = [...this.querySelectorAll('[data-uc-slide]')];
        this.prev = this.querySelector('[data-uc-prev]');
        this.next = this.querySelector('[data-uc-next]');
        if (!this.track) return;
        this.prev?.addEventListener('click', () => this.page(-1), options);
        this.next?.addEventListener('click', () => this.page(1), options);
        this.track.addEventListener('scroll', () => this.update(), {...options,passive:true});
        this.addEventListener('shopify:block:select', e => {
          const slide = this.slides.find(s => s.dataset.blockId === e.detail.blockId || s.contains(e.target));
          if (slide) this.track.scrollTo({left:slide.offsetLeft - this.track.offsetLeft,behavior:'instant'});
        }, options);
        this.observer = new ResizeObserver(() => this.measure());
        this.observer.observe(this.track);
        this.measure();
      }
      measure() {
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        this.carousel.classList.toggle('is-scrollable', max >= 3);
        const media = this.querySelector('.uc__media');
        if (media) this.style.setProperty('--uc-arrow-top', (media.offsetHeight / 2) + 'px');
        this.update();
      }
      update() {
        if (!this.prev || !this.next) return;
        const x = this.track.scrollLeft;
        this.prev.disabled = x <= 2;
        this.next.disabled = x >= this.track.scrollWidth - this.track.clientWidth - 2;
      }
      page(direction) {
        const first = this.slides[0];
        if (!first) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = first.getBoundingClientRect().width + gap;
        const visible = Math.max(1, Math.floor((this.track.clientWidth + gap) / step + 0.05));
        this.track.scrollBy({
          left: direction * step * visible,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["up-cinematic-testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('up-cinema-reviews')) {
    customElements.define('up-cinema-reviews', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.dots = [...this.querySelectorAll('[data-dot]')];
        this.current = 0;
        this.delay = Math.max(3000, Number(this.dataset.delay) || 6000);
        this.pauseOnHover = this.dataset.pauseHover !== 'false';
        this.auto = this.dataset.auto === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches && !(window.Shopify && Shopify.designMode);
        this.controller = new AbortController();
        const opts = {signal:this.controller.signal};
        this.querySelector('[data-prev]')?.addEventListener('click',()=>this.show(this.current-1),opts);
        this.querySelector('[data-next]')?.addEventListener('click',()=>this.show(this.current+1),opts);
        this.dots.forEach((dot,i)=>dot.addEventListener('click',()=>this.show(i),opts));
        this.addEventListener('shopify:block:select',e=>{
          const i=this.slides.findIndex(slide=>slide.dataset.blockId===e.detail.blockId);
          if(i>=0)this.show(i);
        },opts);
        if(this.pauseOnHover){
          this.addEventListener('mouseenter',()=>this.stop(),opts);
          this.addEventListener('mouseleave',()=>this.start(),opts);
        }
        document.addEventListener('visibilitychange',()=>{if(document.hidden)this.stop();else this.start()},opts);
        this.addEventListener('focusin',()=>this.stop(),opts);
        this.addEventListener('focusout',()=>this.start(),opts);
        let x=0;
        this.addEventListener('touchstart',e=>{x=e.touches[0].clientX;this.stop();},{...opts,passive:true});
        this.addEventListener('touchend',e=>{const dx=e.changedTouches[0].clientX-x;if(Math.abs(dx)>55)this.show(this.current+(dx<0?1:-1));this.start();},{...opts,passive:true});
        this.start();
      }
      disconnectedCallback(){this.controller?.abort();this.stop()}
      show(index){
        if(!this.slides.length)return;
        this.current=(index+this.slides.length)%this.slides.length;
        this.slides.forEach((slide,i)=>{
          const active=i===this.current;
          slide.classList.toggle('is-active',active);
          if(active){slide.removeAttribute('aria-hidden');slide.removeAttribute('inert')}
          else {slide.setAttribute('aria-hidden','true');slide.setAttribute('inert','')}
        });
        this.dots.forEach((dot,i)=>{dot.classList.toggle('is-active',i===this.current);dot.setAttribute('aria-current',String(i===this.current))});
        this.start();
      }
      stop(){clearInterval(this.timer);this.timer=null}
      start(){this.stop();if(this.auto&&this.slides.length>1&&!document.hidden&&(!this.pauseOnHover||!this.matches(':hover'))&&!this.contains(document.activeElement))this.timer=setInterval(()=>this.show(this.current+1),this.delay)}
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["up-reviews-new"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('unplastiq-reviews')) {
    customElements.define('unplastiq-reviews', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.setup());
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        clearTimeout(this.timer);
        this.events?.abort();
        this.observer?.disconnect();
        this.inView?.disconnect();
      }
      setup() {
        this.events?.abort();
        this.observer?.disconnect();
        this.inView?.disconnect();
        clearTimeout(this.timer);
        this.events = new AbortController();
        const options = {signal:this.events.signal};
        this.track = this.querySelector('.ur__track');
        this.cards = [...this.querySelectorAll('[data-ur-card]')];
        this.prev = this.querySelector('[data-ur-prev]');
        this.next = this.querySelector('[data-ur-next]');
        this.toggle = this.querySelector('[data-ur-toggle]');
        this.dots = this.querySelector('.ur__dots');
        this.arrows = this.querySelector('.ur__arrows');
        if (!this.track) return;

        /* Auto slide state */
        const reduce = matchMedia('(prefers-reduced-motion: reduce)');
        this.interval = Math.max(2000, parseInt(this.dataset.interval, 10) || 5000);
        this.pauseOnHover = this.dataset.pauseHover !== 'false';
        this.autoEnabled = this.dataset.autoplay === 'true' && !reduce.matches && !(window.Shopify && Shopify.designMode);
        this.userPaused = false;
        this.hovering = false;
        this.focusing = false;
        this.touching = false;
        this.visible = true;
        this.pageVisible = !document.hidden;

        this.prev.addEventListener('click', () => { this.go(this.index - 1); this.schedule(); }, options);
        this.next.addEventListener('click', () => { this.go(this.index + 1); this.schedule(); }, options);
        this.track.addEventListener('scroll', () => this.update(), {...options,passive:true});
        this.track.addEventListener('keydown', e => {
          if (e.target !== this.track) return;
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault();this.go(this.index + (e.key === 'ArrowRight' ? 1 : -1));this.schedule();
          }
        }, options);
        this.addEventListener('shopify:block:select', e => {
          const card = this.cards.find(c => c.dataset.blockId === e.detail.blockId);
          if (card) {
            this.go(this.cards.indexOf(card));
          }
        }, options);

        if (this.toggle) {
          this.toggle.hidden = !this.autoEnabled;
          this.toggle.addEventListener('click', () => {
            this.userPaused = !this.userPaused;
            this.renderToggle();
            this.schedule();
          }, options);
        }

        if (this.autoEnabled) {
          if (this.pauseOnHover) {
            this.addEventListener('mouseenter', () => { this.hovering = true; this.schedule(); }, options);
            this.addEventListener('mouseleave', () => { this.hovering = false; this.schedule(); }, options);
          }
          /* Keyboard focus pauses; mouse clicks on the arrows do not */
          this.addEventListener('focusin', e => {
            if (e.target.matches(':focus-visible')) { this.focusing = true; this.schedule(); }
          }, options);
          this.addEventListener('focusout', () => { this.focusing = false; this.schedule(); }, options);
          /* Touch: pause while the finger is down and shortly after */
          this.track.addEventListener('touchstart', () => { this.touching = true; this.schedule(); }, {...options,passive:true});
          this.track.addEventListener('touchend', () => { this.touching = false; this.schedule(); }, {...options,passive:true});
          this.track.addEventListener('touchcancel', () => { this.touching = false; this.schedule(); }, {...options,passive:true});
          document.addEventListener('visibilitychange', () => { this.pageVisible = !document.hidden; this.schedule(); }, options);
          if ('IntersectionObserver' in window) {
            this.inView = new IntersectionObserver(entries => {
              this.visible = entries[entries.length-1].isIntersecting;
              this.schedule();
            }, {threshold:0.25});
            this.inView.observe(this);
          }
        }

        this.observer = new ResizeObserver(() => this.measure());
        this.observer.observe(this.track);
        this.measure();
      }
      renderToggle() {
        if (!this.toggle) return;
        const paused = this.userPaused;
        this.toggle.querySelector('[data-ur-icon-pause]').hidden = paused;
        this.toggle.querySelector('[data-ur-icon-play]').hidden = !paused;
        this.toggle.setAttribute('aria-label', paused ? 'Start automatic sliding' : 'Pause automatic sliding');
      }
      canRun() {
        return this.autoEnabled && this.positions && this.positions.length > 1 &&
          !this.userPaused && !this.hovering && !this.focusing && !this.touching &&
          this.visible && this.pageVisible;
      }
      schedule() {
        clearTimeout(this.timer);
        if (!this.canRun()) return;
        this.timer = setTimeout(() => {
          this.advance();
          this.schedule();
        }, this.interval);
      }
      advance() {
        this.go(this.index >= this.positions.length - 1 ? 0 : this.index + 1);
      }
      measure() {
        const max = Math.max(0,this.track.scrollWidth-this.track.clientWidth);
        const trackRect = this.track.getBoundingClientRect();
        this.positions = this.cards.map(card => {
          const rect = card.getBoundingClientRect();
          const center = rect.left - trackRect.left + this.track.scrollLeft + rect.width / 2;
          return Math.max(0, Math.min(max, center - this.track.clientWidth / 2));
        });
        this.arrows.hidden = max < 3;
        this.dots.hidden = max < 3;
        this.dots.replaceChildren();
        this.positions.forEach((x,i) => {
          const b = document.createElement('button');
          b.type='button';b.className='ur__dot';
          b.setAttribute('aria-label',`Show review position ${i+1} of ${this.positions.length}`);
          b.setAttribute('aria-controls',this.track.id);
          b.addEventListener('click',()=>{this.go(i);this.schedule();},{signal:this.events.signal});
          this.dots.append(b);
        });
        this.update();
        this.renderToggle();
        this.schedule();
      }
      update() {
        if (!this.positions) return;
        const x = this.track.scrollLeft;
        this.index = this.positions.reduce((best,pos,i) => Math.abs(pos-x)<Math.abs(this.positions[best]-x)?i:best,0);
        this.prev.disabled = this.index === 0;
        this.next.disabled = this.index === this.positions.length - 1;
        this.cards.forEach((card,i)=>card.classList.toggle('is-spotlight',i===this.index));
        [...this.dots.children].forEach((b,i)=>b.setAttribute('aria-current',String(i===this.index)));
      }
      go(index) {
        const target = Math.max(0,Math.min(this.positions.length-1,index));
        this.track.scrollTo({left:this.positions[target],behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
